import { useEffect, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { LANGUAGES_TYPE } from "../types/language.d"

export const useLanguage = () => {
  const { i18n } = useTranslation()
  const selectedLanguage: string = useMemo(() => {
    return i18n.language
      ? i18n.language
      : i18n.options?.fallbackLng?.toString() || LANGUAGES_TYPE.HE
  }, [i18n.language, i18n.options?.fallbackLng])

  const onLanguageChange = (lng: string) => {
    i18n.changeLanguage(lng)
    document.documentElement.lang = i18n.language
    document.documentElement.dir =
      i18n.language === LANGUAGES_TYPE.HE ? "rtl" : "ltr"
  }

  useEffect(() => {
    document.documentElement.lang = i18n.language
    document.documentElement.dir =
      i18n.language === LANGUAGES_TYPE.HE ? "rtl" : "ltr"
  }, [i18n.language])

  return [selectedLanguage, onLanguageChange] as const
}
